import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sp-common-rate-card',
  templateUrl: './common-rate-card.component.html',
  styleUrls: ['./common-rate-card.component.scss']
})
export class CommonRateCardComponent implements OnInit {

  @Input() data: any = []
  constructor() { }

  ngOnInit(): void {
  }

}
